import { createPermission } from '@backstage/plugin-permission-common';

export const catalogUserUpdatePermission = createPermission({
  name: 'catalog.user.update',
  attributes: { action: 'update' },
});
